const accordion_titles = document.querySelectorAll('.accordion_titles');

accordion_titles.forEach(accordion_title => {
  accordion_title.addEventListener('click', event => {
    const active = document.querySelector('.accordion_titles.active');
    if (active && active !== accordion_title) {
      active.classList.toggle('active');
      active.nextElementSibling.style.display = 'none';
      accordion_title.setAttribute('aria-expanded', false);
    }
    accordion_title.classList.toggle('active');
    const description = accordion_title.nextElementSibling;
    if (accordion_title.classList.contains('active')) {
      description.style.display = 'block';
      accordion_title.setAttribute('aria-expanded', true);
      const componentName = accordion_title.getAttribute('data-component-name');
      const componentText = accordion_title.getAttribute('data-component-text').replace(/(<([^>]+)>)/gi, "");
      const buttontext = accordion_title.getAttribute('data-component-faqTitle');
      sendClickInfoToAnalyticsCMS(
        componentName,
        '',
        componentText,
        'accordion',
        '',
        buttontext,
        event,
      );
    } else {
      description.style.display = 'none';
      accordion_title.setAttribute('aria-expanded', false);
    }
  });
});

document.body.addEventListener('click', event => {
  accordion_titles.forEach(accordion => {
    if (accordion && event.target.parentElement !== accordion.parentElement) {
      if (accordion.classList.contains('active')) {
        accordion.classList.toggle('active');
        accordion.nextElementSibling.style.display = 'none';
        accordion.setAttribute('aria-expanded', false);
      }
    }
  });
});